import PropTypes from 'prop-types';
import React from 'react';
import * as dateTimeHelper from 'utils/LocalDateTimeHelper';

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY HH:mm
//  Example:        17-10-2016 14:00
//
///////////////////////////////////////////////////////////////////////////////

export function LocalDateTime(props) {
  const {
    iso : dt,
    className: className = "date-time"
  } = props;

  const dateTimeFormatted = dateTimeHelper.localDateTime(dt);
  return (
    <span className={className}>{dateTimeFormatted}</span>
  );
}
LocalDateTime.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY HH:mm:ss
//  Example:        17-10-2016 14:00:00
//
///////////////////////////////////////////////////////////////////////////////

export function LocalDateTimeLong(props) {
  const {
    iso : dt,
    className: className = "date-time-long"
  } = props;

  const dateTimeFormatted = dateTimeHelper.localDateTimeLong(dt);
  return (
    <span className={className}>{dateTimeFormatted}</span>
  );
}
LocalDateTimeLong.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  YYYY-MM-DD
//  Example:        2016-10-17
//
///////////////////////////////////////////////////////////////////////////////

export function LocalIsoDate(props) {
  const {
    iso : dt,
    className: className = "date"
  } = props;

  const dateFormatted = dateTimeHelper.isoDate(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalIsoDate.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY
//  Example:        17-10-2016
//
///////////////////////////////////////////////////////////////////////////////

export function LocalDate(props) {
  const {
    iso : dt,
    className: className = "date"
  } = props;

  const dateFormatted = dateTimeHelper.localDate(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalDate.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  ddd DD
//  Example:        Mon 17
//
///////////////////////////////////////////////////////////////////////////////

export function LocalDateShort(props) {
  const {
    iso : dt,
    className: className = "date-short"
  } = props;

  const dateFormatted = dateTimeHelper.localDateShort(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalDateShort.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  Do MMMM YYYY
//  Example:        17th October 2016
//
///////////////////////////////////////////////////////////////////////////////

export function LocalFullDate(props) {
  const {
    iso : dt,
    className: className = "full-date"
  } = props;

  const dateFormatted = dateTimeHelper.localFullDate(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalFullDate.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]),
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  ddd MMMM DD YYYY
//  Example:        Mon October 17 2016
//
///////////////////////////////////////////////////////////////////////////////

export function LocalFullDateLong(props) {
  const {
    iso : dt,
    className: className = "full-date-long"
  } = props;

  const dateFormatted = dateTimeHelper.localFullDateLong(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalFullDateLong.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD/MM/YY
//  Example:        17/10/16
//
///////////////////////////////////////////////////////////////////////////////

export function LocalFullDateShort(props) {
  const {
    iso : dt,
    className: className = "full-date-short"
  } = props;

  const dateFormatted = dateTimeHelper.localFullDateShort(dt);
  return (
    <span className={className}>{dateFormatted}</span>
  );
}
LocalFullDateShort.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  HH:mm:ss
//  Example:        14:00:00
//
///////////////////////////////////////////////////////////////////////////////

export function LocalTime(props) {
  const {
    iso : dt,
    className: className = "time"
  } = props;

  const timeFormatted = dateTimeHelper.localTime(dt);
  return (
    <span className={className}>{timeFormatted}</span>
  );
}
LocalTime.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  HH:mm
//  Example:        14:00
//
///////////////////////////////////////////////////////////////////////////////

export function LocalTimeShort(props) {
  const {
    iso : dt,
    className: className = "time-short"
  } = props;

  const timeFormatted = dateTimeHelper.localTimeShort(dt);
  return (
    <span className={className}>{timeFormatted}</span>
  );
}
LocalTimeShort.propTypes = {
  iso: PropTypes.oneOfType([ PropTypes.string, PropTypes.instanceOf(Date)]).isRequired,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./modules/Common/components/LocalDateTime.js